const VALIDATION_MESSAGES = {
  "draft1_onlyOne": "Please select only one checkbox for this section.",
  "draft2_onlyOne": "Please select only one checkbox for this section.",
  "draft3_onlyOne": "Please select only one checkbox for this section.",
  "draft4_onlyOne": "Please select only one checkbox for this section.",
  "draft5_onlyOne": "Please select only one checkbox for this section.",
  "draft6_onlyOne": "Please select only one checkbox for this section.",
  "draft7_onlyOne": "Please select only one checkbox for this section.",
  "draft8_onlyOne": "Please select only one checkbox for this section.",

  "spillage1_onlyOne": "Please select only one checkbox for this section.",
  "spillage2_onlyOne": "Please select only one checkbox for this section.",
  "spillage3_onlyOne": "Please select only one checkbox for this section.",
  "spillage4_onlyOne": "Please select only one checkbox for this section.",
  "spillage5_onlyOne": "Please select only one checkbox for this section.",
  "spillage6_onlyOne": "Please select only one checkbox for this section.",
  "spillage7_onlyOne": "Please select only one checkbox for this section.",
  "spillage8_onlyOne": "Please select only one checkbox for this section.",

  "CVA1_onlyOne": "Please select only one checkbox for this section.",
  "CVA2_onlyOne": "Please select only one checkbox for this section.",
  "CVA3_onlyOne": "Please select only one checkbox for this section.",
  "CVA4_onlyOne": "Please select only one checkbox for this section.",
  "CVA5_onlyOne": "Please select only one checkbox for this section.",
  "CVA6_onlyOne": "Please select only one checkbox for this section.",
  "CVA7_onlyOne": "Please select only one checkbox for this section.",
  "CVA8_onlyOne": "Please select only one checkbox for this section.",
} 

const useValidation = (control) => {
  const { getValues } = control;

  return {
    "mainHeaterDraft_pass": () => ({
      validate: () => {
        const options = ["mainHeaterDraft_pass", "mainHeaterDraft_fail", "mainHeaterDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft1_onlyOne"];
      },
    }),
    "otherHeaterDraft_pass": () => ({
      validate: () => {
        const options = ["otherHeaterDraft_pass", "otherHeaterDraft_fail", "otherHeaterDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft2_onlyOne"];
      },
    }),
    "gasDraft_pass": () => ({
      validate: () => {
        const options = ["gasDraft_pass", "gasDraft_fail", "gasDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft3_onlyOne"];
      },
    }),
    "solidFuelWoodstoveDraft_pass": () => ({
      validate: () => {
        const options = ["solidFuelWoodstoveDraft_pass", "solidFuelWoodstoveDraft_fail", "solidFuelWoodstoveDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft4_onlyOne"];
      },
    }),
    "waterHeaterDraft_pass": () => ({
      validate: () => {
        const options = ["waterHeaterDraft_pass", "waterHeaterDraft_fail", "waterHeaterDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft5_onlyOne"];
      },
    }),
    "cookTopDraft_pass": () => ({
      validate: () => {
        const options = ["cookTopDraft_pass", "cookTopDraft_fail", "cookTopDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft6_onlyOne"];
      },
    }),
    "ovenBroilerDraft_pass": () => ({
      validate: () => {
        const options = ["ovenBroilerDraft_pass", "ovenBroilerDraft_fail", "ovenBroilerDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft7_onlyOne"];
      },
    }),
    "clothesDryerDraft_pass": () => ({
      validate: () => {
        const options = ["clothesDryerDraft_pass", "clothesDryerDraft_fail", "clothesDryerDraft_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["draft8_onlyOne"];
      },
    }),

    // new section
    "mainHeaterSpillage_yes": () => ({
      validate: () => {
        const options = ["mainHeaterSpillage_yes", "mainHeaterSpillage_no", "mainHeaterSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage1_onlyOne"];
      },
    }),
    "otherHeaterSpillage_yes": () => ({
      validate: () => {
        const options = ["otherHeaterSpillage_yes", "otherHeaterSpillage_no", "otherHeaterSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage2_onlyOne"];
      },
    }),
    "gasSpillage_yes": () => ({
      validate: () => {
        const options = ["gasSpillage_yes", "gasSpillage_no", "gasSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage3_onlyOne"];
      },
    }),
    "solidFuelWoodstoveSpillage_yes": () => ({
      validate: () => {
        const options = ["solidFuelWoodstoveSpillage_yes", "solidFuelWoodstoveSpillage_no", "solidFuelWoodstoveSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage4_onlyOne"];
      },
    }),
    "waterHeaterSpillage_yes": () => ({
      validate: () => {
        const options = ["waterHeaterSpillage_yes", "waterHeaterSpillage_no", "waterHeaterSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage5_onlyOne"];
      },
    }),
    "cookTopSpillage_yes": () => ({
      validate: () => {
        const options = ["cookTopSpillage_yes", "cookTopSpillage_no", "cookTopSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage6_onlyOne"];
      },
    }),
    "ovenBroilerSpillage_yes": () => ({
      validate: () => {
        const options = ["ovenBroilerSpillage_yes", "ovenBroilerSpillage_no", "ovenBroilerSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage7_onlyOne"];
      },
    }),
    "clothesDryerSpillage_yes": () => ({
      validate: () => {
        const options = ["clothesDryerSpillage_yes", "clothesDryerSpillage_no", "clothesDryerSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["spillage8_onlyOne"];
      },
    }),

    // new section

    "mainHeaterCVA_pass": () => ({
      validate: () => {
        const options = ["mainHeaterCVA_pass", "mainHeaterCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA1_onlyOne"];
      },
    }),
    "otherHeaterCVA_pass": () => ({
      validate: () => {
        const options = ["otherHeaterCVA_pass", "otherHeaterCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA2_onlyOne"];
      },
    }),
    "gasCVA_pass": () => ({
      validate: () => {
        const options = ["gasCVA_pass", "gasCVA_fail", "gasSpillage_NA"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA3_onlyOne"];
      },
    }),
    "solidFuelWoodstoveCVA_pass": () => ({
      validate: () => {
        const options = ["solidFuelWoodstoveCVA_pass", "solidFuelWoodstoveCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA4_onlyOne"];
      },
    }),
    "waterHeaterCVA_pass": () => ({
      validate: () => {
        const options = ["waterHeaterCVA_pass", "waterHeaterCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA5_onlyOne"];
      },
    }),
    "cookTopCVA_pass": () => ({
      validate: () => {
        const options = ["cookTopCVA_pass", "cookTopCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA6_onlyOne"];
      },
    }),
    "ovenAndBroilerCVA_pass": () => ({
      validate: () => {
        const options = ["ovenAndBroilerCVA_pass", "ovenAndBroilerCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA7_onlyOne"];
      },
    }),
    "clothesDryerCVA_pass": () => ({
      validate: () => {
        const options = ["clothesDryerCVA_pass", "clothesDryerCVA_fail"];
        const count = options.filter(option => !!getValues(option)).length;
        return (count === 1) || VALIDATION_MESSAGES["CVA8_onlyOne"];
      },
    }),
  };
};

export default useValidation;
